import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logoVV from '../assets/logo_vv_mono.svg';
import { useT } from '../i18n/LanguageContext';

const NAV_LINKS = [
  { to: '/',         key: 'nav.home'    },
  { to: '/vinhos',   key: 'nav.vinhos'  },
  { to: '/loja',     key: 'nav.loja'    },
  { to: '/vinhas',   key: 'nav.vinhas'  },
  { to: '/sobre',    key: 'nav.sobre'   },
  { to: '/contacto', key: 'nav.contacto'},
];

const LEGAL_LINKS = [
  { to: '/privacidade',     key: 'footer.legal.privacy' },
  { to: '/termos',          key: 'footer.legal.terms'   },
  { to: '/cookies',         key: 'footer.legal.cookies' },
];

export default function Footer() {
  const t = useT();
  const year = new Date().getFullYear();

  /* — Newsletter (mock, sem backend ligado) — */
  const [email,  setEmail]  = useState('');
  const [status, setStatus] = useState(null); // 'ok' | 'err' | null

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!/\S+@\S+\.\S+/.test(email)) {
      setStatus('err');
      return;
    }
    // Aqui ligaria ao backend / Mailchimp / etc.
    setStatus('ok');
    setEmail('');
  };

  return (
    <footer
      style={{
        background: 'linear-gradient(180deg, var(--clr-azul-veludo) 0%, var(--clr-noir) 100%)',
        padding: 'var(--sp-16) 0 var(--sp-10)',
        color: '#ffffff',
      }}
    >
      <div className="container">

        {/* ── 4 colunas ── */}
        <div className="footer__top-grid">

          {/* Col 1 — Marca */}
          <div>
            <Link
              to="/"
              aria-label="Douro Nostrum — página inicial"
              style={{ display: 'inline-block' }}
            >
              <img
                src={logoVV}
                alt="Douro Nostrum"
                style={{
                  width: '100px',
                  height: 'auto',
                  display: 'block',
                  filter: 'brightness(0) invert(1)',
                  opacity: 0.9,
                }}
              />
            </Link>
            <p className="footer__brand-tagline">
              {t('footer.tagline').split('\n').map((line, i) => (
                <React.Fragment key={i}>
                  {i > 0 && <br />}
                  {line}
                </React.Fragment>
              ))}
            </p>
            <p className="footer__brand-house">{t('footer.brandLine')}</p>
          </div>

          {/* Col 2 — Navegar */}
          <div>
            <p className="footer__col-title">{t('footer.nav')}</p>
            <nav>
              <ul className="footer__list">
                {NAV_LINKS.map(({ to, key }) => (
                  <li key={to}>
                    <Link to={to} className="footer__link">
                      {t(key)}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          {/* Col 3 — Contacto */}
          <div>
            <p className="footer__col-title">{t('footer.contact')}</p>
            <address className="footer__address">
              {t('footer.address')}
            </address>
            <a
              href="mailto:info@douronostrum.pt"
              className="footer__link"
            >
              info@douronostrum.pt
            </a>

            <div className="footer__social">
              <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__link"
                aria-label="Facebook"
              >
                {t('footer.social.facebook')}
              </a>
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__link"
                aria-label="Instagram"
              >
                {t('footer.social.instagram')}
              </a>
            </div>
          </div>

          {/* Col 4 — Newsletter */}
          <div>
            <p className="footer__col-title">{t('footer.newsletter.title')}</p>
            <p className="footer__newsletter-lead">
              {t('footer.newsletter.lead')}
            </p>
            <form
              className="footer__newsletter-form"
              onSubmit={handleSubmit}
              noValidate
            >
              <input
                type="email"
                className="footer__newsletter-input"
                placeholder={t('footer.newsletter.placeholder')}
                value={email}
                onChange={(e) => { setEmail(e.target.value); setStatus(null); }}
                aria-label={t('footer.newsletter.placeholder')}
              />
              <button
                type="submit"
                className="footer__newsletter-btn"
                aria-label={t('footer.newsletter.cta')}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="13 6 19 12 13 18" />
                </svg>
              </button>
            </form>
            {status === 'ok' && (
              <p className="footer__newsletter-msg">{t('footer.newsletter.success')}</p>
            )}
            {status === 'err' && (
              <p className="footer__newsletter-msg footer__newsletter-msg--err">
                {t('footer.newsletter.invalid')}
              </p>
            )}
          </div>
        </div>

        {/* ── Bottom strip — copyright + legal ── */}
        <div className="footer__bottom">
          <p className="footer__copyright">
            © {year}
            <span className="footer__brand-name">Casa Agrícola Meneses</span>
            · {t('footer.copyright')}
          </p>
          <ul className="footer__legal">
            {LEGAL_LINKS.map(({ to, key }) => (
              <li key={to}>
                <Link to={to}>{t(key)}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
}
